@for (banner of banners$ | async; track $index) {
  <app-banner [banner]="banner" (dismiss)="onDismiss($event)"></app-banner>
}
